import api from '../api';
import {
  BoardTemplate,
  CreateBoardTemplateRequest,
  UpdateBoardTemplateRequest,
  CreateBoardTemplateColumnRequest,
  UpdateBoardTemplateColumnRequest,
  ReorderColumnsRequest,
  BoardTemplateColumn
} from '../../interfaces/boardTemplate';

const BASE_URL = '/board-templates';

export const getBoardTemplates = async (projectId?: string): Promise<BoardTemplate[]> => {
  const response = await api.get(BASE_URL, { params: { projectId } });
  // Map the templates to the format our UI expects
  return response.data.data.map((template: any) => ({
    id: template.id,
    name: template.name,
    description: template.description || '',
    createdAt: template.createdAt,
    columnsCount: template.columnsCount || 0,
    // Include column data from the API response
    columns: template.columns ? template.columns.map((col: any) => ({
      name: col.name,
      position: col.position
    })) : [],
    canEdit: template.canEdit
  }));
};

export const getBoardTemplateById = async (id: string, projectId?: string): Promise<BoardTemplate> => {
  const response = await api.get(`${BASE_URL}/${id}`, { params: { projectId } });
  const templateData = response.data.data;
  return {
    id: templateData.id,
    name: templateData.name,
    description: templateData.description || '',
    createdAt: templateData.createdAt,
    lastUpdatedAt: templateData.lastUpdatedAt,
    // Mapear as colunas do formato da API para nosso formato de interface
    columns: templateData.columns ? templateData.columns.map((col: any) => ({
      name: col.name,
      position: col.position
    })) : [],
    canEdit: templateData.canEdit
  };
};

export const createBoardTemplate = async (template: CreateBoardTemplateRequest, projectId?: string): Promise<BoardTemplate> => {
  const response = await api.post(BASE_URL, template, { params: { projectId } });
  const templateData = response.data.data;
  return {
    id: templateData.id,
    name: templateData.name,
    description: templateData.description || '',
    createdAt: templateData.createdAt,
    lastUpdatedAt: templateData.lastUpdatedAt,
    // Mapear as colunas do formato da API para nosso formato de interface
    columns: templateData.columns ? templateData.columns.map((col: any) => ({
      name: col.name,
      position: col.position
    })) : [],
    canEdit: templateData.canEdit || true // Se acabou de criar, pode editar
  };
};

export const updateBoardTemplate = async (id: string, template: UpdateBoardTemplateRequest, projectId?: string): Promise<BoardTemplate> => {
  const response = await api.put(`${BASE_URL}/${id}`, template, { params: { projectId } });
  const templateData = response.data.data;
  return {
    id: templateData.id,
    name: templateData.name,
    description: templateData.description || '',
    createdAt: templateData.createdAt,
    lastUpdatedAt: templateData.lastUpdatedAt,
    // Mapear as colunas do formato da API para nosso formato de interface
    columns: templateData.columns ? templateData.columns.map((col: any) => ({
      name: col.name,
      position: col.position
    })) : [],
    canEdit: templateData.canEdit || true // Se conseguiu atualizar, pode editar
  };
};

export const deleteBoardTemplate = async (id: string, projectId?: string): Promise<void> => {
  await api.delete(`${BASE_URL}/${id}`, { params: { projectId } });
};

// Na nossa nova implementação, não temos APIs separadas para colunas
// Todas as operações de colunas são feitas através do template
